export default {
  eyebrow: 'Portal partener',
  title: 'Branding',
  description: 'Aspectul portalului dvs. white-label și al paginii de autentificare.',
  page: {
    read_only_notice: 'Doar citire. Faceți clic pe Editare pentru a modifica orice valoare.',
    editing_notice: 'Editare — modificările sunt vizibile pentru echipa și clienții dvs.',
  },
  branding: {
    scope_hint:
      'Se aplică portalului dvs. white-label și paginii de autentificare — nu vitrinelor restaurantelor dvs., care sunt branduite per restaurant.',
    upload: 'Încarcă logo',
    logo: {
      label: 'Logo',
      hint: 'Afișat pe suprafețele dvs. white-label.',
    },
    circle_logo: {
      label: 'Favicon / logo circular',
      hint: 'Logo pătrat folosit ca favicon și avatar. Opțional — poate fi eliminat.',
    },
    splash_image: {
      label: 'Imagine de autentificare',
      hint: 'Afișată pe pagina dvs. de autentificare white-label. Recomandat: cel puțin 1200px lățime. Opțional — poate fi eliminată.',
    },
    footer_note: 'Mai multe opțiuni de branding (culori secundare) vor urma.',
  },
  form: {
    primary_color: {
      label: 'Culoarea principală a brandului',
      hint: 'Personalizează portalul partenerului și autentificarea.',
    },
    dashboard_subdomain: {
      label: 'Slug autentificare partener',
      hint: 'Slug cu litere mici — identifică brandul dvs. în linkul de autentificare al echipei (?partner=…).',
      placeholder: 'nume-partener',
    },
    login_url: {
      label: 'Link autentificare echipă',
      hint: 'Distribuiți acest link echipei dvs. — deschide pagina de autentificare cu brandul dvs.',
    },
    file: {
      label: 'Imagine',
    },
  },
  login_url_warning: {
    title: 'Schimbați linkul de autentificare al echipei?',
    description:
      'Linkul de autentificare al echipei se va schimba la {{url}}. Distribuiți noul link de acum înainte — cel vechi nu mai afișează brandul dvs.',
    description_no_url:
      'Linkul de autentificare al echipei se va schimba. Distribuiți noul link de acum înainte — cel vechi nu mai afișează brandul dvs.',
  },
  login_url_changed: {
    title: 'Linkul de autentificare al echipei s-a schimbat',
    description: 'Echipa dvs. se autentifică acum la {{url}}. Salvați noul link și distribuiți-l echipei dvs.',
  },
  buttons: {
    edit: 'Editare',
    cancel: 'Anulare',
    save: 'Salvare',
  },
  toasts: {
    load_error: 'Nu s-a putut încărca brandul dvs.',
    failed_to_save_changes: 'Salvarea modificărilor a eșuat',
    changes_got_saved: 'Modificările au fost salvate',
    logo_uploaded: 'Logo încărcat',
    logo_upload_failed: 'Încărcarea logo-ului a eșuat',
    logo_removed: 'Logo eliminat',
    logo_remove_failed: 'Eliminarea logo-ului a eșuat',
    file_too_large: 'Fișierul este prea mare. Dimensiunea maximă este de {{max}} MB.',
    image_too_narrow: 'Imaginea de autentificare trebuie să aibă cel puțin {{min}}px lățime.',
  },
};
